export interface AddTopicFormType {
  topicType: string;
  topic: string;
  deliverables: string[];
  measurementMinute: string;
  measurementOther: number | null;
  activityStatus: string;
  participantStatus: string[];
  triggerBilling: boolean;
  lastContactDate: boolean;
  triggerTouch: boolean;
  country?: string;
  countryMeasurementMinute: string;
  countryMeasurementOther: number;
  "en-US"?: string;
  "en-GB"?: string;
  "fr-FR"?: string;
  "pt-BR"?: string;
  "ja-JP"?: string;
}

export const AddTopicFormKey = {
  topicType: "topicType",
  topic: "topic",
  deliverables: "deliverables",
  measurementMinute: "measurementMinute",
  measurementOther: "measurementOther",
  activityStatus: "activityStatus",
  participantStatus: "participantStatus",
  triggerBilling: "triggerBilling",
  lastContactDate: "lastContactDate",
  triggerTouch: "triggerTouch",
  country: "country",
  countryMeasurementMinute: "countryMeasurementMinute",
  countryMeasurementOther: "countryMeasurementOther",
  measurementName: "measurementName",
  "en-US": "en-US",
  "en-GB": "en-GB",
  "fr-FR": "fr-FR",
  "pt-BR": "pt-BR",
  "ja-JP": "ja-JP",
} as const;

export const topicTypeKey = {
  existingTopic: "existingTopic",
  newTopic: "newTopic",
};

export const AddTopicFormDefaultValues = {
  [AddTopicFormKey.topicType]: topicTypeKey.existingTopic,
  [AddTopicFormKey.topic]: "",
  [AddTopicFormKey.deliverables]: [],
  [AddTopicFormKey.measurementMinute]: "",
  [AddTopicFormKey.measurementOther]: null,
  [AddTopicFormKey.activityStatus]: "",
  [AddTopicFormKey.participantStatus]: [],
  [AddTopicFormKey.triggerBilling]: false,
  [AddTopicFormKey.lastContactDate]: false,
  [AddTopicFormKey.triggerTouch]: false,
  [AddTopicFormKey.country]: "",
  [AddTopicFormKey.countryMeasurementMinute]: "",
  [AddTopicFormKey.countryMeasurementOther]: undefined,
  [AddTopicFormKey.measurementName]: "",
  "en-US": "",
  "en-GB": "",
  "fr-FR": "",
  "pt-BR": "",
  "ja-JP": "",
};
